import { FC, memo } from 'react';
import styles from './style.module.css';

interface Props {
  text?: string;
}

export const HoverInfo: FC<Props> = memo(({ text }: Props) => {
  return (
    <div className={styles.hoverInfo}>
      <p>{text}</p>
    </div>
  );
});

HoverInfo.displayName = 'HoverInfo';
